export function PrimaryActionButton(props) {
    return (
        <button
            className={`font-roboto bg-[#2f805a] hover:bg-[#40976e] text-[1.6rem] min-w-[144px] px-12 py-6 font-semibold cursor-pointer text-white rounded-full border-none flex items-center justify-center ${
                props.className ? props.className : ""
            }`}
            onClick={props.onClick}
        >
            {props.label}
        </button>
    );
}
